export default __webpack_public_path__ + "static/media/CV_Esperance_AHOUISSOU_fullstack.f2d7e8a9.pdf";